import React from 'react';
import Cnh from '../CnhComponent';
import PersonalInformation from '../PersonalIformantion';
import SelfieComponent from '../SelfieComponent';
import VehicleData from '../VehicleData';
import CrlvComponent from '../CrlvComponent';
import VehiclePhotos from '../VehiclePhotos';

interface IChildrenModal {
  step: number;
}

const ChildrenModal: React.FC<IChildrenModal> = ({ step }) => {
  const renderChildren = () => {
    switch (step) {
      case 1:
        return <PersonalInformation />;
      case 2:
        return <SelfieComponent />;
      case 3:
        return <Cnh />;
      case 4:
        return <CrlvComponent />;
      case 5:
        return <VehicleData />;
      case 6:
        return <VehiclePhotos />;
      default:
        return <PersonalInformation />;
    }
  };

  return <>{renderChildren()}</>;
};

export default ChildrenModal;
